module.exports = __webpack_public_path__ + "static/reserve-vehicle-widget-c88147087d9cb6fccbfc71ebdb247096.jpg";